import React, { useState, useRef, useEffect } from "react";
import { LuEllipsisVertical } from "react-icons/lu";
import { ICategory } from "../../types";

interface DropdownActionsProps {
  category: ICategory;
  onEdit: (category: ICategory) => void;
  onDelete: (category: ICategory) => void;
}

const CategoryDropdownActions = ({
  category,
  onEdit,
  onDelete,
}: DropdownActionsProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const LuEllipsisVerticalIcon = LuEllipsisVertical as React.ElementType;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className="p-2 hover:bg-gray-100 rounded-full"
      >
        <LuEllipsisVerticalIcon className="text-gray-600 text-lg" />
      </button>
      {dropdownOpen && (
        <div className="absolute left-0 mt-2 w-24 bg-white shadow-md border rounded-md z-10">
          <button
            className="w-full text-left px-4 py-2 hover:bg-gray-100 text-sm"
            onClick={(e) => {
              e.stopPropagation();
              onEdit(category);
              setDropdownOpen(false);
            }}
          >
            Edit
          </button>
          <button
            className="w-full text-left px-4 py-2 hover:bg-red-100 text-sm text-red-600"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(category);
              setDropdownOpen(false);
            }}
          >
            Delete
          </button>
        </div>
      )}
    </div>
  );
};

export default CategoryDropdownActions;
